module.exports = __webpack_public_path__ + "img/Alien_symbol_1.a3766ef9.png";